import React from 'react';
import styles from './FavoritedBand.module.scss';
import StarIcon from './star-solid.svg';

function FavoritedBand(props) {
    const { favorite } = props;

    if (!favorite) return null;

    return (
        <div className={styles.FavoritedBand}>
            <div className={styles.content}>
                <StarIcon />
            </div>
        </div>
    );
}

export default FavoritedBand;
